const STORAGE_KEY = 'currentLocale'
const FALLBACK_LOCALE = 'en'

import Vue from 'vue'
import VueI18n from 'vue-i18n'

import de from './de'
import en from './en'

const messages = {
  en,
  de
}

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: window.localStorage.getItem(STORAGE_KEY) || FALLBACK_LOCALE,
  fallbackLocale: FALLBACK_LOCALE,
  messages,
})

Vue.prototype.$locale = {
	change (locale) {
    i18n.locale = locale;
    window.localStorage.setItem(STORAGE_KEY, locale)
	},
	current () {
		return i18n.locale;
  },
  available () {
    return  Object.keys(i18n.messages)
  }
}



// WEBPACK FOOTER //
// ./src/i18n/index.js